import { makeStyles } from '@material-ui/core';

const useMapStyles = makeStyles((theme) => ({
  root: {
    padding: '0 5px',
    backgroundColor: 'white',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    height: '100%',
    borderRadius: '50px',
    '& *': {
      userSelect: 'none',
    },
    position: 'relative',
    width: '100%',
    display: 'flex',
  },
  inputs: {
    maxWidth: '86.65%',
  },
  go: {
    margin: '10px 0',
    marginLeft: 'auto',
    maxWidth: '55px',
    backgroundColor: theme.palette.landing.main,
    borderRadius: '50%',
  },
  inputContainer: {
    zIndex: 99,
    position: 'relative',
    height: '100%',
    borderRadius: '50px',
    border: '1px solid transparent',
    padding: '0 0 0 5px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#f7f4f4',
    },

    '& .MuiFormControl-root': {
      display: 'block',
      height: '100%',
    },
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '1.636rem !important',
      color: 'black',
      transform: 'translate(5px, 25px)',
      fontWeight: 'bold',
    },
  },
  divider: {
    maxWidth: '0px',
    height: '30px',
    borderRight: '2px solid #ededed',
  },

  mouseOver: {
    borderRight: '2px solid transparent !important',
  },
  noDivider: {
    borderRight: '2px solid transparent !important',
  },

  first: {
    marginLeft: '20px',
  },
  focused: {
    backgroundColor: '#f9f9f9',
    boxShadow: '2px 0px 6px 2px rgb(0 0 0 / 16%)',

    '& .MuiInputLabel-outlined': {
      transform: 'translate(15px, 10px) scale(0.9)',
      color: 'rgb(0, 0, 0, 0.8)',
    },
  },
  searchData: (props) => ({
    cursor: 'normal !important',
    transition: 'all .1s ease-in-out',
    position: 'absolute',
    width: '600px',
    // overflow: 'auto',
    display: props.focused === -1 ? 'none' : 'flex',
    left: '0',
    height: props.focused === -1 ? '0' : '200px',
    backgroundColor: '#f9f9f9',
    top: '-205px',
    // bottom: '-205px',
    borderRadius: '10px',
    boxShadow: '1px 12px 6px 0 rgb(0 0 0 / 16%)',
    zIndex: 99,
  }),
  searchDataBottom: (props) => ({
    cursor: 'normal !important',
    transition: 'all .1s ease-in-out',
    position: 'absolute',
    width: '600px',
    // overflow: 'auto',
    display: props.focused === -1 ? 'none' : 'flex',
    left: '0',
    height: props.focused === -1 ? '0' : '200px',
    backgroundColor: '#f9f9f9',
    top: '75px',
    // bottom: '-205px',
    borderRadius: '10px',
    boxShadow: '1px 12px 6px 0 rgb(0 0 0 / 16%)',
    zIndex: 99,
  }),
  firstInput: {
    transform: 'translate(-5px, 0)',
    paddingLeft: '10px',
  },
  tInsider: {
    fontSize: '1.2rem',
    paddingLeft: '14px',
    paddingTop: '4px',
    opacity: '0.5',
  },
}));

export default useMapStyles;
